import React from 'react';
import { Box } from '@mui/material';

const GlassContainer = ({ children, sx }) => (
    <Box sx={{
        backdropFilter: 'blur(15px)',
        background: 'rgba(255, 255, 255, 0.03)',
        borderRadius: 4,
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
        p: 3,
        mb: 3,
        ...sx
    }}>
        {children}
    </Box>
);

export default GlassContainer;
